module.exports = __webpack_public_path__ + "img/ESE.6ad03fe3.svg";